module.exports = __webpack_public_path__ + "static/ComplexHome-e4860b2296075c5d03f50f966ca22f82.png";